// extracted by mini-css-extract-plugin
export default {"Badge-default-primary":"theme-default_Badge-default-primary__CdK54","Badge-default-secondary":"theme-default_Badge-default-secondary__nslK0"};